import { usePermissions } from '@/hooks/use-auth';
import { NAVIGATION, type NavItem } from '@/lib/navigation';

/** Módulos que o usuário pode acessar, na ordem do menu. */
export function useVisibleModules(): NavItem[] {
  const { canAny } = usePermissions();
  return NAVIGATION.filter((item) => !item.permissions || canAny(...item.permissions));
}
